export default __webpack_public_path__ + "static/media/card_checklist.6efe51aa.svg";